import styled from 'styled-components'

export const ProviderSection = styled.div``

export const ProviderContent = styled.div`
  display: flex;
  align-items: center;
`

export const JustificationColumn = styled.div`
  display: flex;
  flex-direction: column;
`
